export default __webpack_public_path__ + "static/media/Knockout-49Liteweight-Regular.39c4a186.otf";